module.exports = __webpack_public_path__ + "static/media/border-outer.54d0a1eb.svg";